import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { handleGetStripeProducts, handleUsers } from "../axios";
import { useSelector } from "react-redux";
import BreadCrumb from "./BreadCrumb";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftIcon, DownloadCloudIcon } from "lucide-react";
import { convertToIST } from "../utils/utils";
import CustomLoader from "./CustomLoader";
import NoDataComponent from "./NoDataComponent";
import { useQuery } from "react-query";

const StripeProductTable = () => {
  const { token } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "100px",
    },

    {
      name: "Price_id",
      selector: (row) => row.price_id,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Interval",
      selector: (row) => row.interval,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      sortable: true,
      width: "100px",
    },
    {
      name: "currency",
      selector: (row) => row.currency,
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      selector: (row) => (row.active === true ? "active" : "disabled"),
      sortable: true,
      width: "100px",
    },

    {
      name: "Created At",
      selector: (row) => convertToIST(row.createdAt),
      sortable: true,
      width: "150px",
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        borderRight: "1px solid #ddd",
        fontWeight: "bold",
        letterSpacing: "0em",
        alignItems: "center",
      },
    },
    cells: {
      style: {
        borderRight: "1px solid #ddd",
        alignItems: "center",
      },
    },
  };

  const { data: stripeProducts } = useQuery(["stripeProducts"], () =>
    handleGetStripeProducts()
  );

  // Function to filter users based on search term

  const filteredUsers = stripeProducts?.data?.filter(
    (user) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.currency.includes(searchTerm) ||
      user.interval.includes(searchTerm) ||
      user.price_id.includes(searchTerm)
  );

  //   const handleDownload = () => {
  //     const csvContent =
  //       "data:text/csv;charset=utf-8," +
  //       "ID,Name,Email,CreatedAt\n" +
  //       filteredUsers
  //         .map((row) => {
  //           return `"${row.googleId}",${row.name},${row.email},"${convertToIST(
  //             row.createdAt
  //           )}"`;
  //         })
  //         .join("\n");

  //     const encodedUri = encodeURI(csvContent);
  //     const link = document.createElement("a");
  //     link.setAttribute("href", encodedUri);
  //     link.setAttribute("download", "Users_report.csv");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   };

  return (
    <div>
      <div className="my-4">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="outline-none ring-1 ring-gray-200 2xl:w-[300px] xl:w-[300px] lg:w-[300px] md:w-[300px] w-full h-10 rounded-[8px] indent-3 mt-2 focus:ring-2 focus:ring-indigo-300 transition-all duration-300"
          />
        </div>
      </div>
      <div className="border border-gray-200 mt-2">
        <DataTable
          columns={columns}
          data={filteredUsers}
          pagination
          paginationRowsPerPageOptions={[10, 50, 100, 500]}
          highlightOnHover
          progressPending={loading}
          progressComponent={loading ? <CustomLoader /> : "NoData"}
          customStyles={customStyles}
          noDataComponent={<NoDataComponent />}
          responsive
        />
      </div>
    </div>
  );
};

export default StripeProductTable;
